import { ReactElement } from "react";
import styles from "./TextSkeleton.module.less";

export type TextSkeletonProps = {
	lines?: 1 | 2 | 3 | 4 | 5 | 6;
};

export const TextSkeleton = (props: TextSkeletonProps): ReactElement => {
	const {
		lines = 1
	} = props;

	return (
		<span
			className={styles.root}
			style={{"--_number-of-lines": lines}}
		/>
	);
};
TextSkeleton.displayName = "TextSkeleton";